import { render } from "./MonitorStatusLabel.vue?vue&type=template&id=4dfdbdab"
import script from "./MonitorStatusLabel.vue?vue&type=script&lang=js"
export * from "./MonitorStatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__